import { Button, Flex } from "@mantine/core";
import { useTranslation } from "react-i18next";
import style from "./privacy.module.css";

import { IconArrowRight } from "@tabler/icons-react";
import { Link, useNavigate } from "react-router-dom";
import CEELogo from "./../../../../assets/CEELogo.webp";
import GDPRCompliant from "./../../../../assets/GDPRCompliant.webp";

const PrivacySegment = () => {
    const { t } = useTranslation(["landing-page"]);
    const navigate = useNavigate();

    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <div className={style.flex}>
                    <div className={style.leftWrapper}>
                        <h2 className={style.header}>{t("privacy.title")}</h2>

                        <p className={style.text}>{t("privacy.description")}</p>

                        <Button onClick={() => navigate("/privacy")} color="dark" radius={"xl"} variant="outline" rightIcon={<IconArrowRight size={"1rem"} />}>
                            {t("privacy.read_more")}
                        </Button>
                    </div>

                    <Flex className={style.complianceWrapper} mt={"3rem"} rowGap={"1rem"} w={"100%"} wrap={"wrap"} justify={"space-between"}>
                        <Link to="https://eur-lex.europa.eu/eli/reg/2016/679/oj/eng" target="_blank" referrerPolicy="no-referrer">
                            <img className={style.gdprCompliant} src={GDPRCompliant} alt={t("privacy.gdpr_alt")}></img>
                        </Link>

                        <Link to="https://www.cee.org/" target="_blank" referrerPolicy="no-referrer">
                            <img className={style.gdprCompliant} src={CEELogo} alt={t("privacy.cee_alt")}></img>
                        </Link>
                    </Flex>
                </div>
            </div>
        </div>
    );
};

export default PrivacySegment;
